import React, { useState, useEffect } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import axios from 'axios';

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: '#32325d',
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '16px',
      '::placeholder': {
        color: '#aab7c4',
      },
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a',
    },
  },
};

const BuyTokens = () => {
  const [tokenAmount, setTokenAmount] = useState(5); // Default to 5 tokens
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const stripe = useStripe();
  const elements = useElements();

  // Scroll to the top of the page when the component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return; // Stripe.js has not loaded yet
    }

    setIsLoading(true); // Show loading indicator

    try {
      const userId = localStorage.getItem('user_id'); // Get the logged-in user's ID

      // Create a payment intent
      const response = await axios.post(`${process.env.REACT_APP_API_URL || 'https://api.eatourshorts.com'}/create-payment-intent`, {
        user_id: userId,
        token_amount: tokenAmount,
      });

      const { clientSecret } = response.data;

      // Confirm the payment
      const result = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: elements.getElement(CardElement),
        },
      });

      if (result.error) {
        setError(result.error.message);
        setSuccess('');
      } else if (result.paymentIntent.status === 'succeeded') {
        // Notify the backend of the successful payment
        await axios.post(`${process.env.REACT_APP_API_URL || 'https://api.eatourshorts.com'}/payment-success`, {
          paymentIntentId: result.paymentIntent.id,
        });

        setSuccess('Payment successful! Tokens have been added to your account.');
        setError('');
      }
    } catch (err) {
      console.error('Error processing payment:', err);
      setError('Failed to process payment.');
      setSuccess('');
    } finally {
      setIsLoading(false); // Hide loading indicator
    }
  };

  return (
    <div
      style={{
        padding: '20px',
        fontFamily: 'Arial, sans-serif',
        color: '#333',
        lineHeight: '1.6',
        background: 'linear-gradient(to bottom, #f9f9f9, #e6ffe6)', // Subtle green gradient for a money-related theme
        minHeight: '100vh', // Full viewport height
      }}
    >
      <h1
        style={{
          textAlign: 'center',
          color: '#28a745', // Green for a money-related theme
          marginBottom: '15px',
        }}
      >
        Buy Tokens
      </h1>
  
      {/* Informational Message */}
      <p
        style={{
          color: '#555',
          marginBottom: '50px',
          textAlign: 'center',
          fontSize: '17px',
          maxWidth: '600px',
          margin: '0 auto',
        }}
      >
        Simply put: It costs money to maintain this website. Now, if you're a broke filmmaker self-financing your passion projects (as I've been), please keep your money and put it towards equipment or your crew. You can get tokens by watching and giving feedback on other people's films.   <br />
        <br /> However, if you're doing well for yourself and want to support this community space for filmmakers, please consider purchasing tokens. You'll be able to get your films way more reviews and help me keep the lights on here.   <br />
        <br /> Thank you. - Leon   <br />
        <br />
      </p>
  
      {error && (
        <p
          style={{
            color: 'red',
            textAlign: 'center',
            fontWeight: 'bold',
            marginBottom: '30px',
          }}
        >
          {error}
        </p>
      )}
      {success && (
        <p
          style={{
            color: 'green',
            textAlign: 'center',
            fontWeight: 'bold',
            marginBottom: '30px',
          }}
        >
          {success}
        </p>
      )}
  
      <form
        onSubmit={handleSubmit}
        autoComplete="off"
        style={{
          maxWidth: '400px',
          margin: '0 auto',
          padding: '20px',
          border: '1px solid #ccc',
          borderRadius: '10px',
          backgroundColor: '#fff',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        }}
      >
        <label
          style={{
            display: 'block',
            marginBottom: '30px',
            fontWeight: 'bold',
            color: '#333',
          }}
        >
          Select Token Amount:
          <select
            value={tokenAmount}
            onChange={(e) => setTokenAmount(parseInt(e.target.value, 10))}
            style={{
              display: 'block',
              width: '100%',
              padding: '10px',
              marginTop: '5px',
              border: '1px solid #ccc',
              borderRadius: '5px',
              fontSize: '16px',
            }}
          >
            <option value={2}>2 Tokens - $15</option>
            <option value={5}>5 Tokens - $35</option>
            <option value={10}>10 Tokens - $60</option>
            <option value={20}>20 Tokens - $99</option>
          </select>
        </label>
  
        <div style={{ margin: '20px 0' }}>
          <CardElement
            options={{
              ...CARD_ELEMENT_OPTIONS,
              hidePostalCode: true, // Optional: Hide postal code field
            }}
            style={{
              padding: '10px',
              border: '1px solid #ccc',
              borderRadius: '5px',
            }}
          />
        </div>
  
        <button
          type="submit"
          disabled={!stripe || isLoading}
          style={{
            width: '100%',
            padding: '10px 15px',
            backgroundColor: isLoading ? '#ccc' : '#28a745', // Gray when loading, green otherwise
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            fontSize: '16px',
            cursor: isLoading ? 'not-allowed' : 'pointer',
            transition: 'background-color 0.2s',
          }}
          onMouseEnter={(e) => {
            if (!isLoading) e.target.style.backgroundColor = '#218838';
          }}
          onMouseLeave={(e) => {
            if (!isLoading) e.target.style.backgroundColor = '#28a745';
          }}
        >
          {isLoading ? 'Processing...' : 'Pay'}
        </button>
      </form>
    </div>
  );
};

export default BuyTokens;